module.exports = __webpack_public_path__ + "static/session-62a8689b369d5ce7117de911d8c2692d.jpg";